<template>
<!--  <v-card><v-card-text>{{$route.params.id}}</v-card-text></v-card>-->
  <v-app style="max-height: 100px">
    <v-alert
        border="bottom"
        colored-border
        type="warning"
        class="mx-2 mt-4"
        elevation="2"
    >
      به زودی
    </v-alert>
  </v-app>
</template>

<script>
export default {
  name: "update"
}
</script>

<style scoped>

</style>